export function useGlobalLoading() {
  const loading = useState<boolean>('globalLoading', () => false)
  return {
    loading,
    startLoading: () => (loading.value = true),
    stopLoading: () => (loading.value = false),
  }
}
